import type { ResponseAnnotation } from '@reados/contracts';

/** ReadOSTranscriptTextSelectionAdapter / ReadexAccentPalette, unchanged order. */
const palette = ['#2F8CFF', '#22C7D8', '#20C997', '#35C759', '#F2A93B', '#FF4D7D', '#C06BFF', '#6C63FF', '#8B5CF6', '#38BDF8', '#2DD4BF', '#FF6B5F'];
export function annotationAccent(annotations: readonly ResponseAnnotation[]): string {
  const first = annotations[0];
  if (!first) return palette[0];
  const groupId = (first as ResponseAnnotation & { groupId?: string }).groupId;
  const seed = groupId?.trim().toLowerCase() || JSON.stringify([first.sourceThreadId, first.sourceMessageId, first.selectedText,
    first.sourceRanges?.map(range => [range.start, range.end]) || []]);
  let hash = 2166136261;
  for (let index = 0; index < seed.length; index++) { hash ^= seed.charCodeAt(index); hash = Math.imul(hash, 16777619); }
  return palette[(hash >>> 0) % palette.length];
}

export function annotationHighlightColor(annotations: readonly ResponseAnnotation[]) {
  const hex = annotationAccent(annotations);
  return { red: parseInt(hex.slice(1, 3), 16) / 255, green: parseInt(hex.slice(3, 5), 16) / 255, blue: parseInt(hex.slice(5, 7), 16) / 255, alpha: 1 };
}
